import { render, staticRenderFns } from "./logoIcon.vue?vue&type=template&id=78541c5c&"
import script from "./logoIcon.vue?vue&type=script&lang=js&"
export * from "./logoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports